module.exports = __webpack_public_path__ + "img/InheritTextAlign.6021822b.svg";